import RepetitionInterval from '@/domain/termine/components/RepetitionInterval';
import { DatePickerFormField } from '@/domain/termine/features/UpdateTermin/shared/FormFields/DatePickerFormField';
import { TerminWiederholung } from '@/domain/termine/shared/types';
import { useTranslation } from 'react-i18next';
import { RepetitionIntervalDrawer } from '@/domain/termine/features/UpdateTermin/Mobile/components/RepetitionIntervalDrawer';
import { Field, FieldLabel } from '@e2n/ui';
import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared/types';
import { IndividualRepetitionCard } from '@/domain/termine/features/UpdateTermin/Desktop';
import { IndividualRepetitionDrawer } from '@/domain/termine/features/UpdateTermin/Mobile/components/IndividualRepetitionDrawer';
import { useState } from 'react';

export function RepetitionIntervalFormField({ form }: UpdateTermineFormProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-col gap-4 w-full">
      <form.Field name="wiederholung">
        {(field) => (
          <Field className="flex flex-col w-full gap-1">
            <FieldLabel>{t('domain.termine.repeat')}</FieldLabel>
            <div className="block md:hidden">
              <RepetitionIntervalDrawer
                value={field.state.value ?? TerminWiederholung.OHNE}
                onChange={(value) => {
                  field.handleChange(value);
                  if (value === TerminWiederholung.INDIVIDUELL) {
                    setOpen(true);
                  }
                }}
              />
            </div>
            <div className="hidden md:block">
              <RepetitionInterval
                value={field.state.value}
                onChange={field.handleChange}
              />
            </div>
          </Field>
        )}
      </form.Field>
      <form.Subscribe selector={(state) => state.values.wiederholung}>
        {(selectedRepetition) => (
          <>
            {selectedRepetition !== TerminWiederholung.OHNE &&
              selectedRepetition !== TerminWiederholung.INDIVIDUELL && (
                <DatePickerFormField name="wiederholungBis" form={form} />
              )}

            {selectedRepetition === TerminWiederholung.INDIVIDUELL && (
              <div className="flex w-full min-w-0 flex-col gap-1">
                <div className="hidden w-full md:block">
                  <IndividualRepetitionCard form={form} />
                </div>
                <div className="block w-full md:hidden">
                  <IndividualRepetitionDrawer
                    form={form}
                    open={open}
                    onOpenChange={setOpen}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </form.Subscribe>
    </div>
  );
}
